/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { Status } from "../../models/status";
import { TemplateCreate } from "../../models/template-create";
import { TemplateRead } from "../../models/template-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface CreateTemplate$Params {
  organisation_id: string;
  check?: boolean;
  body: TemplateCreate;
}

export function createTemplate(
  http: HttpClient,
  rootUrl: string,
  params: CreateTemplate$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TemplateRead | Status>> {
  const rb = new RequestBuilder(rootUrl, createTemplate.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplateRead | Status>;
    }),
  );
}

createTemplate.PATH = "/surfdomeinen/organisations/{organisation_id}/templates/";
